import {Injectable} from '@angular/core';
import {AuthService} from "./auth.service";

@Injectable()
export class DownloadService {
  constructor(private authService:AuthService) {}

  public DownloadNIBINReport(reportID:string):void{
    window.open('/NIBIN/Report/singlepdf?reportId='+reportID+'&token='+this.authService.getUser().apikey, '_blank')
  }
  public DownloadNIBINReportsByIncidentID(IncidentID:string):void{
    window.open('/NIBIN/Report/MultiPDFByIncident?IncidentID='+IncidentID+'&token='+this.authService.getUser().apikey, '_blank')
  }

  public DownloadNJPOPReport(NJPOPNo:string):void{
    window.open('/NIBIN/NJPOP/GetNJPOPPDF?njpop='+NJPOPNo+'&token='+this.authService.getUser().apikey, '_blank')
  }

  public BallisticsReport(IncidentID:string):string {
    return '/NIBIN/Incident/GetNIBINBallisticsPDF?IncidentID=' + IncidentID + '&token=' + this.authService.getUser().apikey
  }

  public DownloadBallisticsReport(IncidentID:string):void{
    window.open(this.BallisticsReport(IncidentID), '_blank')
  }

}
